@if (origin.country_iso && destination.country_iso) {
<span>
  {{ origin.city_utf8 }}
  <country-flag
    [code]="origin.country_iso"
    [tooltip]="origin.country"
  ></country-flag>
  &nbsp;
  <icon type="arrow-right-short"></icon>
  &nbsp;{{ destination.city_utf8 }}
  <country-flag
    [code]="destination.country_iso"
    [tooltip]="destination.country"
  ></country-flag>
</span>
} @if (!origin.country_iso && !destination.country_iso) {
<span>n/a</span>
}
